import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  max-height: 800px;
`;

export const AppContainer = styled.div`
  max-height: 100%;
`

